import { FormControl } from '@mui/material';

import { styled } from '../../theme/stitches.config';

export const StyledContainer = styled('div', {
  minWidth: 343,
  padding: '16px 0',
});

export const StyledFormControl = styled(FormControl, {
  minWidth: '343px !important',
});
